// extracted by mini-css-extract-plugin
export default {"container":"pagination_container","fullProgress":"pagination_fullProgress"};